<template>
  <router-link to="/" class="home-button">
    <i class="fas fa-home"></i>
  </router-link>
</template>

<script>
export default {
  name: 'HomeButton'
}
</script>

<style scoped>
.home-button {
  position: fixed;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  height: 100px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  z-index: 1000;
}

.home-button:hover {
  background: white;
  transform: translateX(-50%) scale(1.1);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
}

.home-button i {
  color: #333;
  font-size: 3rem;
}

@media (max-width: 768px) {
  .home-button {
    bottom: 20px;
    width: 80px;
    height: 80px;
  }
  
  .home-button i {
    font-size: 2.5rem;
  }
}
</style> 